import React from 'react';
import { render } from '@testing-library/react';
import { Togglebox } from './Togglebox';

describe('Togglebox', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Togglebox
				label="Togglebox label"
				data-auto-sel="automation-selector"
			/>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
